import { useRouter } from 'next/router'
import { logout } from '@/modules/auth/logout'
import { navigationConfig } from './config'
import { Icon } from '../Icon'

export const TopNavigation = () => {
    const router = useRouter()

    const handleLogout = async () => {
        await logout()
        router.push('/login')
    }

    const handleSupportClick = () => {
        const supportUrl = navigationConfig.userMenu.find(
            (item) => item.value === 'supportCenter',
        )?.href
        if (supportUrl) {
            window.open(supportUrl, '_blank')
        }
    }

    return (
        <div className="fixed inset-x-0 top-0 z-[3] flex h-[64px] w-full items-center justify-between px-4 shadow-sm bg-[#1c1c1c]">
            {/* Left side */}
            <div className="flex items-center gap-4">
                <div className="w-[170px]">
                    <Icon type="logo" color="white" width={190} height={20} />
                </div>
            </div>

            {/* Right side */}
            <div className="flex items-center gap-2">
                <button
                    className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-white hover:text-blackcrow"
                    onClick={handleSupportClick}
                >
                    <span className="text-white">Support</span>
                </button>
                <button
                    className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-white hover:text-blackcrow"
                    onClick={handleLogout}
                >
                    <span className="text-white">Logout</span>
                </button>
            </div>
        </div>
    )
}
